import "core-js/modules/es.number.constructor.js";
export var BASE_BADGES_KEY = 'badges';
export var BASE_BADGE_IMAGES_KEY = 'badge-images';
var badgeKeys = {
  /* Badges */
  badges: [BASE_BADGES_KEY],
  singleBadge: function singleBadge(id) {
    return [BASE_BADGES_KEY, 'single', Number(id)];
  },
  /* Badge images */
  badgeImages: [BASE_BADGES_KEY, BASE_BADGE_IMAGES_KEY],
  allBadgeImages: [BASE_BADGES_KEY, BASE_BADGE_IMAGES_KEY, 'all'],
  allBadgeImagesSearch: function allBadgeImagesSearch(query) {
    return [BASE_BADGES_KEY, BASE_BADGE_IMAGES_KEY, 'all', query];
  },
  badgeImagePlaylists: function badgeImagePlaylists(id) {
    return [BASE_BADGES_KEY, BASE_BADGE_IMAGES_KEY, 'playlists', id // id of the badge image
    ];
  }
};
export default badgeKeys;